import { useEffect, useState } from 'react';

/** Seconds since `since`, refreshed every second while mounted. */
export const useElapsedSeconds = (since: string | null | undefined): number => {
  const start = since ? new Date(since).getTime() : NaN;
  const compute = () => (Number.isNaN(start) ? 0 : Math.max(0, (Date.now() - start) / 1000));
  const [elapsed, setElapsed] = useState(compute);
  useEffect(() => {
    setElapsed(compute());
    if (Number.isNaN(start)) return undefined;
    const id = setInterval(() => setElapsed(compute()), 1000);
    return () => clearInterval(id);
  }, [start]);
  return elapsed;
};
